import { useCurrentUser } from "../../AuthWrapper2/hooks/useCurrentUser.js";
import { useReportContext } from "../contexts/ReportContext.js";
import { useMemo } from "react";
import { Icon } from "@therms/atalaya";
import { IoWarning } from "react-icons/io5";
import { jsx, jsxs } from "react/jsx-runtime";
import lodash from "lodash";
//#region src/modules/Reports/shared/ReportAccessWrapper.tsx
function ReportAccessWrapper({ children }) {
	const { report, reportType } = useReportContext(true);
	const user = useCurrentUser();
	if (!useMemo(() => {
		if (report.authors?.find((author) => author.id === user.id)) return true;
		const reportTypeAccessConfig = !!Object.keys(!!reportType.accessConfig).length || !reportType.accessConfig?.canViewUserAndGroupIds?.length;
		const idCheck = lodash.intersection([user.id, ...user.userGroupIds], reportType.accessConfig?.canViewUserAndGroupIds);
		return !!user?.superAdmin || reportTypeAccessConfig || !!idCheck.length;
	}, [reportType, user])) return /* @__PURE__ */ jsxs("div", {
		className: "gap-y-xs pt-xl flex h-full grow flex-col items-center opacity-50",
		children: [/* @__PURE__ */ jsx(Icon, {
			Icon: IoWarning,
			size: "xl",
			color: "caution"
		}), /* @__PURE__ */ jsx("span", {
			className: "text-caution text-center text-lg font-medium",
			children: "Access to this Report is restricted. Please contact your Admin."
		})]
	});
	return /* @__PURE__ */ jsx("div", { children });
}
//#endregion
export { ReportAccessWrapper };

//# sourceMappingURL=ReportAccessWrapper.js.map